(function() {
    var module;

    try {
        // Get current templates module
        module = angular.module('templates');
    } catch (error) {
        // Or create a new one
        module = angular.module('templates', []);
    }

    module.run(["$templateCache", function($templateCache) {
        $templateCache.put('test/question.html', '<div class=\"step step--question\">\n	\n		<a href ng-click=\"stopQuiz()\" class=\"btn btn--secondary btn--stop\"><span>Stoppen</span></a>\n		\n		<div class=\"v-align\">\n			<div class=\"step_content\">\n				<span>{{ question_id }} / {{ total }} </span>\n				<h2>{{question.text}}</h2>\n				\n				<form class=\"question list-option-cnt\" name=\"question[{{question_id}}]\">\n				\n					<label class=\"question_option\" ng-repeat=\"answer in question.answers\">\n						<input type=\"radio\" ng-model=\"answers[question_id]\" ng-value=\"$index + 1\">\n						<span class=\"list-option\">{{answer}}</span>\n					</label>\n					\n					<button class=\"btn\" ng-click=\"next()\" ng-show=\"answers[question_id]\"><span>Volgende</span></button>\n				</form>\n				\n				<button class=\"btn btn--previous btn--secondary\" ng-click=\"previous()\"><span>Terug</span></button>\n		{{scores}}\n			</div>\n		</div>\n</div>\n');
    }]);
})();